// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'distribute-item-vert-center';

export const Component = () => (
  <path d='M20.115 7.89H4.406c-.431 0-.766.144-1.054.432a1.408 1.408 0 0 0-.43 1.054v5.843c0 .431.143.766.43 1.054.288.287.623.43 1.054.43h15.709a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.623.431-1.054V9.376a1.41 1.41 0 0 0-.431-1.054 1.408 1.408 0 0 0-1.054-.431Zm.479 1.485v5.843c0 .335-.144.527-.48.527H4.407c-.335 0-.479-.192-.479-.527V9.375c0-.335.144-.527.48-.527h15.708c.335 0 .479.192.479.527ZM.479 2.958c-.335 0-.479-.144-.479-.48C0 2.145.144 2 .479 2h23.563c.335 0 .48.144.48.479 0 .335-.145.479-.48.479H.48Zm23.563 18.678c.335 0 .48.144.48.479 0 .335-.145.479-.48.479H.48c-.335 0-.479-.144-.479-.48 0-.334.144-.478.479-.478h23.563Z' />
);

export const viewBox = '0 0 25 25';
